// extracted by mini-css-extract-plugin
export default {"thoughts":"testimonial_thoughts__Xp-Ew","errorText":"testimonial_errorText__vrRuq"};